import {Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {HttpOption, Response, StaticMethods} from '../model/GeneralModels';
import {throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {environment} from '../environments/environment';
import {FeedBackService} from '../services/feed-back.service';

@Injectable({
  providedIn: 'root'
})
export class HttpClientWrapperService {

  constructor(private http: HttpClient, public feedBack: FeedBackService) {
  }

  createAuthorizationHeader(authorization?: string) {
    let headers = new HttpHeaders({'Client-Key': environment.clientKey});
    if (authorization) {
      headers = headers.append('Authorization', authorization);
    }
    return headers;
  }

  _http() {
    return this.http;
  }

  get(url, authorization?: string) {
    const options = new HttpOption();
    options.headers = this.createAuthorizationHeader(authorization);
    return this.http.get<Response>(environment.apiUri + url, options).pipe(retry(0), catchError(
      err => StaticMethods.handleError(err, this.feedBack)
    ));
  }

  post(url, data, authorization?: string) {
    const options = new HttpOption();
    options.headers = this.createAuthorizationHeader(authorization);
    return this.http.post<Response>(environment.apiUri + url, data, options).pipe(retry(0), catchError(
      err => StaticMethods.handleError(err, this.feedBack)
    ));
  }

  upload(url, file: File, fileName, authorization?: string) {
    const options = new HttpOption();
    options.headers = this.createAuthorizationHeader(authorization);
    const formData = new FormData();
    formData.append(fileName, file, file.name);
    return this.http.post<Response>( environment.apiUri + url, formData, options).pipe(retry(1), catchError(
      err => StaticMethods.handleError(err, this.feedBack)
      )
    );
  }
}
